/*
  Yulan TCG - Bouton flottant « Signaler un bug » + fenêtre de signalement.
  Markup : snippets/yulan-bug-report.liquid, rendu une fois par page depuis
  layout/theme.liquid.

  Envoi : formulaire natif Shopify {% form 'contact' %}, soumis normalement
  (aucune interception fetch/AJAX) : Shopify gère elle-même sa protection
  anti-spam puis revient sur la page qui contenait le formulaire, où
  form.posted_successfully? / form.errors sont exposés (voir les <script>
  injectés par le Liquid juste après l'ouverture du bloc {% form %}). Comme
  l'envoi est un vrai submit natif, pas besoin du contournement hCaptcha que
  yulan-alerts.js applique au formulaire « customer ».

  Capture d'écran : outil de sélection maison (souris + tactile, via Pointer
  Events) qui dessine un cadre sur la page en cours, puis rend un instantané
  avec html2canvas — chargé à la demande (jamais au chargement de la page,
  pour ne pas alourdir le poids des pages ni le LCP) depuis cdnjs.cloudflare.com.
  La capture reste dans le navigateur du visiteur : Shopify ne permet pas de
  joindre un fichier à l'email du formulaire de contact natif sans application
  payante ; un bouton « Télécharger la capture » est proposé à la place.
*/
(function () {
  'use strict';

  var H2C_URL = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
  var H2C_SRI = 'sha512-BNaRQnYJYiPSqHHDb58B0yaPfCu+Wgds8Gp/gU33kqBtgNS4tSPHuGibyoeqMV/TJlSKda6FXzoEyYGjTe+vXA==';

  var fab = document.getElementById('YulanBugButton');
  var dialog = document.getElementById('YulanBugModal');
  if (!fab || !dialog) return;

  var form = document.getElementById('YulanBugReportForm');
  var fieldsPanel = dialog.querySelector('[data-yulan-bug-fields]');
  var successPanel = dialog.querySelector('[data-yulan-bug-success]');
  var messageField = document.getElementById('YulanBugMessage');
  var nameField = document.getElementById('YulanBugName');
  var categoryField = document.getElementById('YulanBugCategory');
  var descriptionField = document.getElementById('YulanBugDescription');
  var q1 = document.getElementById('YulanBugQ1');
  var q2 = document.getElementById('YulanBugQ2');
  var q3 = document.getElementById('YulanBugQ3');

  var captureStartBtn = dialog.querySelector('[data-yulan-bug-capture-start]');
  var thumbWrap = dialog.querySelector('[data-yulan-bug-thumb]');
  var thumbImg = thumbWrap ? thumbWrap.querySelector('[data-yulan-bug-thumb-img]') : null;
  var downloadBtn = dialog.querySelector('[data-yulan-bug-download]');
  var removeBtn = dialog.querySelector('[data-yulan-bug-remove]');
  var captureBlock = dialog.querySelector('.yulan-bugreport__capture');

  var capOverlay = document.getElementById('YulanBugCapture');
  var capSelection = capOverlay ? capOverlay.querySelector('[data-yulan-bugcap-selection]') : null;
  var capToolbar = capOverlay ? capOverlay.querySelector('[data-yulan-bugcap-toolbar]') : null;
  var capCancelBtn = capOverlay ? capOverlay.querySelector('[data-yulan-bugcap-cancel]') : null;
  var capRedoBtn = capOverlay ? capOverlay.querySelector('[data-yulan-bugcap-redo]') : null;
  var capConfirmBtn = capOverlay ? capOverlay.querySelector('[data-yulan-bugcap-confirm]') : null;

  var capturedCanvas = null;
  var capStart = null;
  var capRect = null;
  var h2cPromise = null;

  var QUESTIONS = [
    { label: 'Que faisiez-vous quand le problème est apparu ?', input: q1 },
    { label: 'Sur quel appareil / navigateur ?', input: q2 },
    { label: 'Le problème se reproduit-il à chaque fois ?', input: q3 }
  ];

  /* ---------- fenêtre de signalement ---------- */
  function showFieldsView() {
    if (fieldsPanel) fieldsPanel.hidden = false;
    if (successPanel) successPanel.hidden = true;
  }

  function showSuccessView() {
    if (fieldsPanel) fieldsPanel.hidden = true;
    if (successPanel) successPanel.hidden = false;
  }

  function openReportModal() {
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.body.classList.add('yulan-modal-open');
  }

  function closeReportModal() {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    document.body.classList.remove('yulan-modal-open');
  }

  fab.addEventListener('click', function () {
    showFieldsView();
    openReportModal();
  });

  dialog.querySelectorAll('[data-yulan-bug-close]').forEach(function (btn) {
    btn.addEventListener('click', closeReportModal);
  });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeReportModal();
  });
  dialog.addEventListener('close', function () {
    document.body.classList.remove('yulan-modal-open');
  });

  /* ---------- message envoyé à Shopify ---------- */
  function buildMessage() {
    var category = (categoryField && categoryField.value) || 'Non précisée';
    var description = ((descriptionField && descriptionField.value) || '').trim();
    var lines = [];
    lines.push('Catégorie : ' + category);
    lines.push('');
    lines.push('Description : ' + (description || '(non renseignée)'));
    lines.push('');
    lines.push('Réponses aux questions suggérées :');
    QUESTIONS.forEach(function (q) {
      var val = q.input ? (q.input.value || '').trim() : '';
      lines.push('- ' + q.label + ' ' + (val || '(sans réponse)'));
    });
    lines.push('');
    lines.push('Page concernée : ' + window.location.href);
    lines.push(
      'Capture jointe : ' +
        (capturedCanvas
          ? 'oui, téléchargée par le client (à demander si besoin, non jointe automatiquement)'
          : 'non')
    );
    return lines.join('\n');
  }

  if (form) {
    form.addEventListener('submit', function () {
      if (messageField) messageField.value = buildMessage();
      if (nameField && !nameField.value) nameField.value = 'Signalement de bug (visiteur du site)';
    });
  }

  /* ---------- html2canvas : chargement à la demande ---------- */
  function loadHtml2Canvas() {
    if (window.html2canvas) return Promise.resolve(window.html2canvas);
    if (h2cPromise) return h2cPromise;
    h2cPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = H2C_URL;
      // v3s : contrôle d'intégrité (SRI) du fichier cdnjs — un fichier modifié sur le CDN serait refusé
      s.integrity = H2C_SRI;
      s.crossOrigin = 'anonymous';
      s.referrerPolicy = 'no-referrer';
      s.async = true;
      s.onload = function () {
        if (window.html2canvas) {
          resolve(window.html2canvas);
        } else {
          h2cPromise = null;
          reject(new Error('html2canvas indisponible'));
        }
      };
      s.onerror = function () {
        h2cPromise = null;
        reject(new Error('html2canvas : échec du chargement'));
      };
      document.head.appendChild(s);
    });
    return h2cPromise;
  }

  /* ---------- outil de capture ---------- */
  function resetCaptureTool() {
    if (capSelection) capSelection.hidden = true;
    if (capToolbar) capToolbar.hidden = true;
    capStart = null;
    capRect = null;
  }

  function startCapture() {
    if (!capOverlay) return;
    closeReportModal();
    resetCaptureTool();
    capOverlay.hidden = false;
    document.body.classList.add('yulan-modal-open');
  }

  function endCapture(reopen) {
    if (capOverlay) capOverlay.hidden = true;
    resetCaptureTool();
    if (reopen) openReportModal();
    else document.body.classList.remove('yulan-modal-open');
  }

  function updateSelectionRect(x1, y1, x2, y2) {
    var left = Math.min(x1, x2);
    var top = Math.min(y1, y2);
    var width = Math.abs(x2 - x1);
    var height = Math.abs(y2 - y1);
    capRect = { left: left, top: top, width: width, height: height };
    if (capSelection) {
      capSelection.style.left = left + 'px';
      capSelection.style.top = top + 'px';
      capSelection.style.width = width + 'px';
      capSelection.style.height = height + 'px';
    }
  }

  function positionToolbar() {
    if (!capToolbar || !capRect) return;
    capToolbar.hidden = false;
    var margin = 10;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var tw = capToolbar.offsetWidth;
    var th = capToolbar.offsetHeight;
    var left = capRect.left + capRect.width - tw;
    var top = capRect.top + capRect.height + margin;
    if (left < margin) left = margin;
    if (left + tw > vw - margin) left = Math.max(margin, vw - margin - tw);
    if (top + th > vh - margin) top = Math.max(margin, capRect.top - th - margin);
    capToolbar.style.left = left + 'px';
    capToolbar.style.top = top + 'px';
  }

  if (capOverlay) {
    capOverlay.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-yulan-bugcap-cancel],[data-yulan-bugcap-redo],[data-yulan-bugcap-confirm]')) return;
      if (capOverlay.setPointerCapture) {
        try {
          capOverlay.setPointerCapture(e.pointerId);
        } catch (err) {
          /* noop */
        }
      }
      capStart = { x: e.clientX, y: e.clientY };
      if (capToolbar) capToolbar.hidden = true;
      if (capSelection) capSelection.hidden = false;
      updateSelectionRect(capStart.x, capStart.y, capStart.x, capStart.y);
      e.preventDefault();
    });

    capOverlay.addEventListener('pointermove', function (e) {
      if (!capStart) return;
      updateSelectionRect(capStart.x, capStart.y, e.clientX, e.clientY);
    });

    var finishDrag = function (e) {
      if (!capStart) return;
      updateSelectionRect(capStart.x, capStart.y, e.clientX, e.clientY);
      capStart = null;
      if (capRect && capRect.width > 12 && capRect.height > 12) {
        positionToolbar();
      } else if (capSelection) {
        capSelection.hidden = true;
      }
    };

    capOverlay.addEventListener('pointerup', finishDrag);
    capOverlay.addEventListener('pointercancel', function () {
      capStart = null;
    });
  }

  if (captureStartBtn) captureStartBtn.addEventListener('click', startCapture);
  if (capCancelBtn) {
    capCancelBtn.addEventListener('click', function () {
      endCapture(true);
    });
  }
  if (capRedoBtn) {
    capRedoBtn.addEventListener('click', function () {
      resetCaptureTool();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && capOverlay && !capOverlay.hidden) {
      endCapture(true);
    }
  });

  function cropCanvas(sourceCanvas, rect) {
    var scale = sourceCanvas.width / window.innerWidth;
    var sx = Math.max(0, Math.round(rect.left * scale));
    var sy = Math.max(0, Math.round(rect.top * scale));
    var sw = Math.max(1, Math.round(rect.width * scale));
    var sh = Math.max(1, Math.round(rect.height * scale));
    var out = document.createElement('canvas');
    out.width = sw;
    out.height = sh;
    out.getContext('2d').drawImage(sourceCanvas, sx, sy, sw, sh, 0, 0, sw, sh);
    return out;
  }

  function showThumbnail(canvas) {
    if (!thumbImg || !thumbWrap) return;
    thumbImg.src = canvas.toDataURL('image/png');
    thumbWrap.hidden = false;
    if (captureStartBtn) captureStartBtn.textContent = 'Reprendre la capture';
  }

  function removeCapture() {
    capturedCanvas = null;
    if (thumbWrap) thumbWrap.hidden = true;
    if (thumbImg) thumbImg.removeAttribute('src');
    if (captureStartBtn) captureStartBtn.textContent = 'Capturer la fenêtre';
  }

  if (removeBtn) removeBtn.addEventListener('click', removeCapture);

  if (downloadBtn) {
    downloadBtn.addEventListener('click', function () {
      if (!capturedCanvas) return;
      capturedCanvas.toBlob(function (blob) {
        if (!blob) return;
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = 'yulan-tcg-bug-' + Date.now() + '.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 4000);
      });
    });
  }

  function showCaptureError() {
    if (!captureBlock) return;
    var err = document.createElement('p');
    err.className = 'yulan-bugreport__error';
    err.textContent =
      'La capture a échoué. Vous pouvez réessayer, ou envoyer votre signalement sans capture.';
    captureBlock.insertAdjacentElement('afterbegin', err);
  }

  if (capConfirmBtn) {
    capConfirmBtn.addEventListener('click', function () {
      if (!capRect || capRect.width < 4 || capRect.height < 4) return;
      var rect = capRect;
      var originalLabel = capConfirmBtn.textContent;
      capConfirmBtn.disabled = true;
      capConfirmBtn.textContent = 'Capture en cours…';
      // masqué avant l'instantané pour que l'outil ne se capture pas lui-même
      if (capOverlay) capOverlay.hidden = true;

      loadHtml2Canvas()
        .then(function (html2canvas) {
          return html2canvas(document.documentElement, {
            backgroundColor: '#ffffff',
            useCORS: true,
            logging: false,
            // Le thème définit des custom elements (ex. product-form) dont le
            // constructeur lit son propre contenu (this.form.querySelector...)
            // dès l'instanciation. Le clonage nœud-par-nœud par défaut de
            // html2canvas recrée ces éléments avant d'y recopier leurs enfants,
            // ce qui fait planter ce constructeur (TypeError sur `this.form`
            // nul). foreignObjectRendering sérialise le DOM réel via <svg>
            // <foreignObject> à la place : pas de reconstruction nœud par
            // nœud, donc pas de nouvel appel à ces constructeurs.
            foreignObjectRendering: true,
            scale: window.devicePixelRatio || 1,
            x: window.scrollX,
            y: window.scrollY,
            width: window.innerWidth,
            height: window.innerHeight,
            windowWidth: document.documentElement.scrollWidth,
            windowHeight: document.documentElement.scrollHeight
          });
        })
        .then(function (canvas) {
          capturedCanvas = cropCanvas(canvas, rect);
          showThumbnail(capturedCanvas);
          endCapture(true);
        })
        .catch(function () {
          endCapture(true);
          showCaptureError();
        })
        .then(function () {
          capConfirmBtn.disabled = false;
          capConfirmBtn.textContent = originalLabel;
        });
    });
  }

  /* ---------- retour après l'envoi (redirection Shopify) ---------- */
  // v3s : Shopify signale « contact_posted » pour TOUS les formulaires de contact de la page. Sur la page Contact,
  // l'envoi du formulaire principal ouvrait donc aussi cette fenêtre. On ne la rouvre que si l'envoi venait
  // bien d'ici : ancre #YulanBugReportForm conservée par la redirection, ou marqueur posé au moment de l'envoi.
  var SENT_KEY = 'yulanBugSent';
  function sentFromHere() {
    if (window.location.hash === '#YulanBugReportForm') return true;
    try {
      var t = parseInt(window.sessionStorage.getItem(SENT_KEY), 10);
      return !!t && Date.now() - t < 10 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }
  if (form) {
    form.addEventListener('submit', function () {
      try { window.sessionStorage.setItem(SENT_KEY, String(Date.now())); } catch (e) {}
    });
  }
  function init() {
    var mine = sentFromHere();
    try { window.sessionStorage.removeItem(SENT_KEY); } catch (e) {}
    if (!mine) return;
    if (window.__yulanBugPosted) {
      showSuccessView();
      openReportModal();
    } else if (window.__yulanBugError) {
      showFieldsView();
      openReportModal();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
